import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

import SearchLabels from "../SearchLabels";
import { changeSearchAudienceFilters } from "../../audiencesManagerActions";

export default function AudiencesSearchLabels({
  afterRemoveCallback,
  searchFilters,
  closeFilters,
}) {
  const { interests } = useSelector((state) => state.audiencesManagerReducer);
  const dispatch = useDispatch();

  const intl = useIntl();

  return (
    <SearchLabels
      intl={intl}
      afterRemoveCallback={afterRemoveCallback}
      searchFilters={searchFilters}
      closeFilters={closeFilters}
      interests={interests}
      changeFilters={(newFilters) =>
        dispatch(changeSearchAudienceFilters(newFilters))
      }
    />
  );
}
